import React from "react";
import { useHistory } from "react-router-dom";
import { RequirementDetailsContent } from "../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";
import { useRequirementsConfig } from "../../../Requirements/useRequirementsConfig";
import { WSPageToolbar } from "@wingspanhq/fe-component-library";
import {
  PAYERS_REQUIREMENTS_PATH,
  getPayerDetailsRequirementsUrl
} from "../../paths";
import { RequirementContextType } from "../../../Requirements/types";
import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

type RequirementsDetailsProps = {
  /**
   * The payer's *account* id, straight off the `:payerId` route segment. Used
   * for the back-link only; the display name is resolved through the config's
   * payer-row lookup, which is keyed on the same id.
   */
  payerAccountId: string;
  requirement: PayeeRequirement;
};

export const RequirementsDetailsRoute: React.FC<RequirementsDetailsProps> = ({
  payerAccountId,
  requirement
}) => {
  const history = useHistory();

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payer
  });

  const title =
    requirementConfig.getRequirementName(requirement) || "Requirement";

  return (
    <>
      <WSPageToolbar
        actions={requirementConfig.getToolbarActions(requirement)}
        breadcrumbs={[
          {
            label: "Clients",
            onClick: () => {
              history.push(PAYERS_REQUIREMENTS_PATH);
            }
          },
          {
            // Empty until the payer row resolves — "Client" keeps the crumb
            // readable instead of collapsing it mid-load.
            label:
              requirementConfig.getRequirementPayerName(requirement) ||
              "Client",
            onClick: () => {
              history.push(getPayerDetailsRequirementsUrl(payerAccountId));
            }
          },
          {
            label: title
          }
        ]}
      />

      <RequirementDetailsContent
        {...requirementConfig}
        contextType={RequirementContextType.Payer}
        requirement={requirement}
      />
    </>
  );
};
